export default function WhatsAppNotificationInfo() {
    return (
        <small>
            <b>NOTE:</b> <br />
            Whatsapp notifications require the latest version of whatsapp.
            It will also require you to accept the latest terms and conditions of whatsapp.
            Click the link below on your phone and it should open whatsapp to agree to the terms: <br />
            <a href="https://wa.me/tos/20210210" target="_blank" rel="noreferrer">Click here to read the terms and conditions</a> <br />
        </small>
    )
}